export const DATATABLE_MAX_ROWS = 25;
export const DATE_LIST_FORMAT = "dd/MM/yyyy kk:mm";
export const SHORT_DATE_FORMAT = "dd/MM/yy";
export const LONG_DATE_FORMAT = "dd/MM/yyyy";

export const NOT_AVAILABLE = "N/A"; // Not available
